import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TemplateEntity } from '../core/template-entity.model';
import { ReplyTemplateService } from '../core/reply-template.service';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { TemplateEntityType } from '../core/template-entity-type.enum';
import { CategoryBase } from '@sb-tools/typescript/models/category-base.model';
import { ReplyTemplatesTree } from '@sb-tools/typescript/models/reply-templates-tree.model';
import { InlineSVGComponent } from '../../Frontend-Inline-SVG-Module/inline-svg.component';

@Component({
    selector: 'sb-reply-templates-list',
    templateUrl: './reply-templates-list.component.html',
    styleUrls: ['./reply-templates-list.component.scss'],
    imports: [InlineSVGComponent],
})
export class ReplyTemplatesListComponent implements OnInit {
    @Input() templatesTree: ReplyTemplatesTree;
    @Input() title: string;

    @Output() replyTemplateChosenEvent = new EventEmitter<TemplateEntity>();

    allTemplates: TemplateEntity[] = [];
    currentFolderName = '';
    filteredTemplates: TemplateEntity[] = [];
    isTextSearchActive: boolean;
    selectedCategoryWithReplyTemplate: TemplateEntity;

    constructor(
        public replyTemplateService: ReplyTemplateService,
        public commonDataService: CommonDataService,
    ) {}

    ngOnInit(): void {
        this.initTemplates();
    }

    chooseTemplate(template: TemplateEntity): void {
        if (template.type === TemplateEntityType.category) {
            this.showChildrenReplyTemplates(template);
            this.isTextSearchActive = false;
            return;
        }

        this.replyTemplateChosenEvent.emit(template);
    }

    filterReplyTemplatesByKeyword(keyword: string): TemplateEntity[] {
        const result = [];
        const searchKeyLower = (keyword || '').toLowerCase();

        if (!searchKeyLower) {
            this.isTextSearchActive = false;
            this.currentFolderName = '';
            this.initTemplates();
            return this.filteredTemplates;
        }

        this.isTextSearchActive = true;

        for (const template of this.allTemplates) {
            this.searchInChildrenNodes(template, searchKeyLower, result);
        }

        this.filteredTemplates = result;
    }

    openRootFolder(): void {
        this.currentFolderName = '';
        this.filteredTemplates = [...this.allTemplates];
    }

    showParentCategoryReplyTemplates(category: CategoryBase): void {
        const template = this.replyTemplateService.getTemplateCategoryById(this.allTemplates, category.id);

        if (template) {
            this.showChildrenReplyTemplates(template);
        }
    }

    private initTemplates(): void {
        this.allTemplates = this.templatesTree.byCategories.map((replyTemplate) => {
            return TemplateEntity.castFromCategoryWithReplyTemplate(replyTemplate);
        });

        this.allTemplates.push(
            ...this.templatesTree.global.map((replyTemplate) => {
                return TemplateEntity.castFromReplyTemplate(replyTemplate);
            }),
        );

        this.filteredTemplates = [...this.allTemplates];
    }

    private searchInChildrenNodes(template: TemplateEntity, keyword: string, result: TemplateEntity[]): void {
        if (template.name.toLowerCase().includes(keyword)) {
            result.push(template);
        }

        for (const child of template.children) {
            this.searchInChildrenNodes(child, keyword, result);
        }
    }

    private showChildrenReplyTemplates(categoryWithReplyTemplate: TemplateEntity): void {
        this.currentFolderName = categoryWithReplyTemplate.name;
        this.selectedCategoryWithReplyTemplate = categoryWithReplyTemplate;

        this.filteredTemplates = [...categoryWithReplyTemplate.children];
    }
}
